webpackJsonp([5],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("SCKt");
__webpack_require__("hBrd");
module.exports = __webpack_require__("co8I");


/***/ }),

/***/ "QU1z":
/***/ (function(module, exports) {

module.exports = "<div class=\"col-12 py-0 pt-3 py-md-3\">\n  <h5><%= category %><span class=\"resultsCount ml-1 d-none\"> (<%= resultCount %>)</span></h5>\n</div>\n"

/***/ }),

/***/ "Yd+E":
/***/ (function(module, exports) {

module.exports = "<!-- Navigation tabs -->\n<div id=\"cigna-navigation-tabs\">\n  <!--\n  <div class=\"nav nav-tabs tabs-heavy mb-m pl-s d-none d-flex\" name=\"tabset\" id=\"tabset\" role=\"tablist\">\n    <a data-tab-label=\"cignaTab\" class=\"nav-item nav-link tab-item mr-xs active\" id=\"cigna-tab\" data-toggle=\"tab\" href=\"#cignaTab\" role=\"tab\" aria-controls=\"cignaTab\" aria-selected=\"true\">Cigna-HealthSpring ()</a>\n  </div>\n  -->\n\n  <!-- Tabs content area (all devices) -->\n  <div class=\"tab-content\" id=\"tabset-content\">\n    <div id=\"cignaTab\" class=\"tab-pane show active itemized-results\" role=\"tabpanel\" aria-labelledby=\"cigna-tab\">\n      <h3 id=\"display-results-label\">\n        <% if (displayResultsLabel) { %>\n          <%= displayResultsLabel.replace('Displaying results for ', '') %>\n        <% } %>\n      </h3>\n      <%= searchResults %>\n      <%= paginationBottom %>\n    </div>\n  </div>\n</div>\n<!-- End Navigation tabs -->\n"

/***/ }),

/***/ "co8I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eVjM":
/***/ (function(module, exports) {

module.exports = "<% breadcrumbs.forEach(function(breadcrumb) { %>\n<li class=\"breadcrumb-item<% if (!breadcrumb.url) { %> active <% } %>\">\n  <% if (breadcrumb.url) { %>\n    <a href=\"<%= breadcrumb.url %>\"><%= breadcrumb.label %></a>\n  <% } else { %>\n    <%= breadcrumb.label %>\n  <% } %>\n</li>\n<% }); %>\n"

/***/ }),

/***/ "f2KB":
/***/ (function(module, exports) {

module.exports = "<% results.forEach(function(result) { %>\n<div class=\"search-results__item\">\n  <div class=\"search-result-header\">\n    <a href=\"<%- url %>/<%- result.link %>\">\n      <%- result.link.indexOf('.pdf') > -1 && typeof(result.title) === 'undefined' ? extractPDFFileName(result.link) : result.title %>\n    </a>\n  </div>\n  <p class=\"search-result-body\"><%= result.description ? result.description.replace(searchedKey, '<strong>$&</strong>') : '' %>\n    <a href=\"<%- url %>/<%- result.link %>\" class=\"search-result-link\"><%- url %>/<%- result.link %></a>\n  </p>\n</div>\n<% }); %>\n"

/***/ }),

/***/ "hBrd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/cigna-frontend/js/index.js
var js = __webpack_require__("XDXe");

// EXTERNAL MODULE: ./node_modules/cigna-frontend/js/click-tracking.js
var click_tracking = __webpack_require__("uIHI");

// EXTERNAL MODULE: ./node_modules/cigna-frontend/js/copyright.js
var copyright = __webpack_require__("dMGD");

// EXTERNAL MODULE: ./node_modules/cigna-frontend/js/events.js + 1 modules
var events = __webpack_require__("jl/e");

// EXTERNAL MODULE: ./node_modules/cigna-frontend/js/accordions.js
var accordions = __webpack_require__("jhuE");

// EXTERNAL MODULE: ./node_modules/cigna-frontend/js/social/share-buttons.js + 1 modules
var share_buttons = __webpack_require__("so9q");

// EXTERNAL MODULE: ./node_modules/cigna-frontend/js/util/storage.js + 9 modules
var storage = __webpack_require__("/9gb");

// EXTERNAL MODULE: ./node_modules/bootstrap/js/dist/collapse.js
var collapse = __webpack_require__("XMH8");
var collapse_default = /*#__PURE__*/__webpack_require__.n(collapse);

// EXTERNAL MODULE: ./node_modules/bootstrap/js/dist/dropdown.js
var dropdown = __webpack_require__("5UFK");
var dropdown_default = /*#__PURE__*/__webpack_require__.n(dropdown);

// EXTERNAL MODULE: ./node_modules/bootstrap/js/dist/modal.js
var modal = __webpack_require__("mPbY");
var modal_default = /*#__PURE__*/__webpack_require__.n(modal);

// EXTERNAL MODULE: ./node_modules/bootstrap/js/dist/tab.js
var dist_tab = __webpack_require__("PiUJ");
var tab_default = /*#__PURE__*/__webpack_require__.n(dist_tab);

// EXTERNAL MODULE: ./node_modules/bootstrap/js/dist/util.js
var util = __webpack_require__("Og9d");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("QmqG");

// EXTERNAL MODULE: ./node_modules/cigna-frontend/js/forms/validator.js + 1 modules
var validator = __webpack_require__("SZrJ");

// EXTERNAL MODULE: ./node_modules/cigna-frontend/js/util/text.js
var util_text = __webpack_require__("oKSz");

// EXTERNAL MODULE: ./node_modules/cigna-frontend/js/util/url.js + 1 modules
var util_url = __webpack_require__("az1j");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("WR00");

// CONCATENATED MODULE: ./src/static/js/utils.js




var utils_getCurrentNavigationTab = function getCurrentNavigationTab() {
  var forceFirst = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var onlyVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var visible = onlyVisible ? ':visible' : '';
  var currentTab = jquery_default()(".middle-nav-links .active".concat(visible)).closest('.nav-item');

  if ((!currentTab || !currentTab.length) && forceFirst) {
    currentTab = jquery_default()(".middle-nav-links .nav-item".concat(visible)).first();
  }

  return currentTab;
};
var utils_getRegionLanguageSection = function getRegionLanguageSection(path) {
  var defaultRegionLanguage = {
    region: 'na',
    language: 'en'
  };

  if (path === '/') {
    return defaultRegionLanguage;
  }

  var regionLanguageRe = /^\/([a-z]{2})\/(?:([a-z]{2})\/)*(?:([a-z-]+)\/)*/i;
  var valid = path.match(regionLanguageRe);

  if (valid) {
    while (valid) {
      var _valid = Object(slicedToArray["a" /* default */])(valid, 4),
          region = _valid[1],
          language = _valid[2],
          section = _valid[3];

      return {
        region: language ? region : undefined,
        language: language || region,
        section: section
      };
    }
  }

  return defaultRegionLanguage;
};
var utils_getNavigationTabFromSection = function getNavigationTabFromSection() {
  var onlyVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var forceFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var _getParams = Object(util_url["b" /* getParams */])(location.search),
      section = _getParams.section;

  var visible = onlyVisible ? ':visible' : '';
  var tab;

  if (section) {
    tab = jquery_default()(".middle-nav-links .nav-item[data-section='".concat(section, "']").concat(visible));
  }

  if ((!tab || !tab.length) && forceFirst) {
    tab = utils_getCurrentNavigationTab(forceFirst, onlyVisible);
  }

  return tab;
};
var getBaseURL = function getBaseURL(path) {
  var _getRegionLanguageSec = utils_getRegionLanguageSection(path),
      region = _getRegionLanguageSec.region,
      language = _getRegionLanguageSec.language,
      section = _getRegionLanguageSec.section;

  return "/".concat([region, language, section].filter(function (item) {
    return item;
  }).join('/'));
};
var utils_pageExists = function pageExists(url) {
  return new Promise(function (resolve, reject) {
    var exists = storage["b" /* session */].get(url);

    if (exists === undefined) {
      jquery_default.a.ajax({
        url: url,
        type: 'HEAD'
      }).done(function () {
        storage["b" /* session */].set(url, true);
        resolve(true);
      }).fail(function () {
        storage["b" /* session */].set(url, false); // eslint-disable-next-line prefer-promise-reject-errors

        reject(false);
      });
    } else {
      var action = exists ? resolve : reject;
      action(exists);
    }
  });
};
var fullUrl = function fullUrl(path) {
  return "".concat(location.origin).concat(path);
};
// CONCATENATED MODULE: ./src/static/js/contact-us.js







var setupValidationUI = function setupValidationUI($form) {
  $form.parsley({
    successClass: 'input-success',
    errorClass: 'input-error',
    classHandler: function classHandler(el) {
      return el.$element.closest('.input-holder');
    },
    errorsWrapper: '<div class="error-feedback"></div>',
    errorTemplate: '<p class="error-message"></p>'
  });
};

var contact_us_prefillForm = function prefillForm() {
  if (jquery_default()('#form19').length) {
    var currentSection = utils_getCurrentNavigationTab(false);

    if (currentSection && currentSection.length) {
      var section = Object(util_text["b" /* toKebabCase */])(currentSection.text().trim());

      var options = Object(toConsumableArray["a" /* default */])(jquery_default()('#field13 option')).filter(function (option) {
        return option.value;
      }).map(function (option) {
        return option.value;
      });

      var foundItem = options.find(function (option) {
        return section.startsWith(option);
      });

      if (foundItem) {
        jquery_default()('#field13').val(foundItem);
      }
    }
  }
};

var contact_us_initPreFillEloquaFields = function initPreFillEloquaFields() {
  var checkReferrer = function checkReferrer() {
    var utmSource = 'field15';
    var utmMedium = 'field16';
    var utmCampaign = 'field17';
    var ref = document.referrer;

    if (ref) {
      // eslint-disable-next-line no-unused-vars
      var checkIfEngine = ['google.com', 'bing.com', 'yahoo.com'].some(function (e) {
        return ref.includes(e) ? jquery_default()("input[id='".concat(utmMedium, "']")).val('organic') : jquery_default()("input[id='".concat(utmMedium, "']")).val('referral');
      });
      var refDomain = ref.match(/:\/\/(.[^/]+)/)[1];
      jquery_default()("input[id='".concat(utmCampaign, "']")).val('(not set)');
      jquery_default()("input[id='".concat(utmSource, "']")).val("".concat(refDomain));
    } else {
      jquery_default()("input[id='".concat(utmSource, "'], input[id='").concat(utmCampaign, "']")).val('(direct)');
      jquery_default()("input[id='".concat(utmMedium, "']")).val('(none)');
    }
  };

  jquery_default()('[data-autopopulate]').each(function (index, el) {
    el = jquery_default()(el);
    var param = el.attr('data-autopopulate');
    var value = Object(util_url["b" /* getParams */])()[param] || '';

    if (!value && !value.length) {
      checkReferrer();
    } else {
      el.val(value);
    }
  });
};
/* harmony default export */ var contact_us = (function () {
  contact_us_prefillForm();
  Object(validator["default"])(setupValidationUI);
  contact_us_initPreFillEloquaFields();
  var reqCheckboxes = jquery_default()('.required-checkbox');
  reqCheckboxes.on('click', function () {
    var allChecked = reqCheckboxes.filter(function (i, a) {
      return a.checked;
    }).length;
    var toggleSubmit = reqCheckboxes.length !== allChecked;
    jquery_default()('.btn-submit-toggle').prop('disabled', toggleSubmit);
  });
});
// EXTERNAL MODULE: ./node_modules/cigna-frontend/js/util/template.js
var template = __webpack_require__("I0Pq");

// EXTERNAL MODULE: ./src/static/js/views/breadcrumbs.tpl.html
var breadcrumbs_tpl = __webpack_require__("eVjM");
var breadcrumbs_tpl_default = /*#__PURE__*/__webpack_require__.n(breadcrumbs_tpl);

// EXTERNAL MODULE: ./src/static/js/views/category.tpl.html
var category_tpl = __webpack_require__("QU1z");
var category_tpl_default = /*#__PURE__*/__webpack_require__.n(category_tpl);

// EXTERNAL MODULE: ./src/static/js/views/pagination.tpl.html
var pagination_tpl = __webpack_require__("vwQg");
var pagination_tpl_default = /*#__PURE__*/__webpack_require__.n(pagination_tpl);

// CONCATENATED MODULE: ./src/static/js/knowledge.js









var knowledeArticleRe = /\/[a-z]{2}\/(?:[a-z]{2}\/)*knowledge\//i;
var pageSize = 9;
var pageLanguage = utils_getRegionLanguageSection(location.pathname).language;
var allLookup = {
  en: 'all',
  fr: 'tous',
  es: 'todo',
  de: 'alles',
  nl: 'alle'
};
/**
 * Need to fake the regions section when accessing /xx/yy/knowledge/* or
 * /yy/knowledge/*, and certain contact pages (links in hero)
 * this is done with a ?section=xyz querystring parameter which we use to get
 * the associated middle-nav tab which as a data-theme attribute.
 * 2 steps, 1 = update the urls that should be to include the section param, 2 =
 * on page load applay the correct theme and select the right tab
 * - if no body class try to figure it out
 *  - get tab from section param
 *   - no param = use first tab
 *   - else get current matching tab tokebabcase of text should match section param
 *  - get theme from tab
 *  - set tab as active
 */

var knowledge_selectTab = function selectTab() {
  var validThemes = Array.from(jquery_default()('.middle-nav-links .nav-item')).map(function (el) {
    return jquery_default()(el).attr('data-theme');
  });

  if (jquery_default()('body').is(validThemes.map(function (theme) {
    return ".theme-".concat(theme);
  }).join(', '))) {
    return;
  }

  var tab = utils_getNavigationTabFromSection(false);
  tab.find('a').addClass('active');
  jquery_default()('body').addClass("theme-".concat(tab.attr('data-theme')));
};
/**
 * update links that only match one of these patterns
 * /xx/yy/knowledge/ or /yy/knowledge/
 * /na/en/knowledge/ or /en/knowledge/
 */


var knowledge_initLinks = function initLinks() {
  var tab = utils_getCurrentNavigationTab();

  if (tab && tab.length) {
    var section = tab.attr('data-section');
    jquery_default()('a[href*="/knowledge/"]').each(function (i, el) {
      var link = jquery_default()(el);
      var href = link.attr('href');

      if (knowledeArticleRe.test(href)) {
        var qs = Object(util_url["c" /* updateQueryString */])({
          section: section
        }, link.get(0));
        link.attr('href', "".concat(href, "?").concat(qs));
      }
    });
  }
};
/**
 * Update Hero and bottom promo links to point to "section"
 * versions if they exist on knowledge article pages. Falls
 * back to generic version if that exists.
 *
 * Assumes naming conventions
 *  /na/en/somepage.html (original)
 *  /na/en/providers/somepage.html
 *  /na/en/governments/somepage.html
 *  etc.
 */


var knowledge_initHeroAndPromoLinks = function initHeroAndPromoLinks() {
  if (knowledeArticleRe.test(location.pathname)) {
    var tab = utils_getNavigationTabFromSection();
    var baseUrl = getBaseURL(tab.find('a').attr('href'));
    var promises = [];
    jquery_default()('.hero-wrapper .btn,.contact-banner .btn').each(function (i, el) {
      el = jquery_default()(el);
      var link = el.get(0); // only site links

      if (link.hostname === location.hostname) {
        var isHeroLink = el.closest('.hero-wrapper').length;
        var page = link.pathname.split('/').pop(); // TODO: URL Ends with /

        var path = "".concat(baseUrl, "/").concat(page);
        var promise = utils_pageExists(fullUrl(path)).then(function () {
          el.attr('href', "".concat(path).concat(link.search));

          if (isHeroLink) {
            el.show();
          }
        }).catch(function () {
          // TODO: look for generic
          // pageExists(link.href).then()
          // Assumes footer links are fine, TODO?
          if (isHeroLink) {
            el.hide();
          }
        });
        promises.push(promise);
      } else {
        el.show();
      }
    });
    Promise.all(promises).then(function () {
      jquery_default()('.hero-left-content .btn:visible').removeClass('hero-cta-btn').removeClass('hero-white-cta-btn');
      jquery_default()('.hero-left-content .btn:visible:even').addClass('hero-cta-btn');
      jquery_default()('.hero-left-content .btn:visible:odd').addClass('hero-white-cta-btn');
    });
  } else {
    jquery_default()('.hero-wrapper .btn').show();
  }
};

var knowledge_initFooterCategoryLinks = function initFooterCategoryLinks() {
  var tab = utils_getNavigationTabFromSection();

  if (tab && tab.length) {
    var baseUrl = getBaseURL(tab.find('a').attr('href'));
    jquery_default()('.cghb-global-footer a[href*="/search-results"], .backBtn').each(function (i, el) {
      el = jquery_default()(el);
      var link = el.get(0);
      var path = "".concat(baseUrl, "/knowledge/search-results.html");
      utils_pageExists(fullUrl(path)).then(el.attr('href', "".concat(path).concat(link.search)));
    });
  }
};

var knowledge_initFilter = function initFilter() {
  var _location = location,
      pathname = _location.pathname,
      search = _location.search;
  var params = Object(util_url["b" /* getParams */])(search);
  var rls = utils_getRegionLanguageSection(pathname);
  var language = rls.language;
  var category = params.category || Object(util_text["a" /* capitalizeEveryWord */])(allLookup[language]) || 'All';
  var categorySelect = jquery_default()('#category-select');
  var validCategories = Array.from(categorySelect.closest('.dropdown-update').find('.dropdown-item')).map(function (el) {
    return jquery_default()(el).text();
  });

  if (validCategories.includes(category)) {
    categorySelect.attr('title', category).text(category);
  }

  if (jquery_default()('.single-article').length) {
    var page = parseInt(params.page || 1, 10);
    var cat = Object(util_text["b" /* toKebabCase */])(category.toLowerCase());
    var uniqArticlesLength = jquery_default()('.single-article').filter(function (i, e) {
      return Object(util_text["b" /* toKebabCase */])(jquery_default()(e).attr('data-category').toLowerCase()) === cat;
    }).length;
    var isAll = Object.values(allLookup).includes(cat);
    var resultCount = isAll ? jquery_default()('.single-article').length : uniqArticlesLength;

    if (resultCount) {
      var totalPages = Math.ceil(resultCount / pageSize);
      var showIndex = 0;
      page = Math.min(page, totalPages);
      jquery_default()('.single-article').each(function (i, el) {
        el = jquery_default()(el);

        if (isAll || Object(util_text["b" /* toKebabCase */])(el.attr('data-category').toLowerCase()) === cat) {
          showIndex += 1;

          if (Math.ceil(showIndex / pageSize) === page) {
            el.show();
          }
        }
      });

      if (validCategories.includes(category)) {
        var categoryHtml = Object(template["a" /* default */])(category_tpl_default.a, {
          category: category,
          resultCount: resultCount
        });
        jquery_default()('.icon-list.one-column').parent().before(categoryHtml); // Kind of hackish
      }

      var paginationHtml = Object(template["a" /* default */])(pagination_tpl_default.a, {
        page: page,
        totalPages: totalPages,
        resultCount: resultCount,
        rangeStart: pageSize * (page - 1) + 1,
        rangeEnd: Math.min(pageSize * page, resultCount),
        nextUrl: "".concat(location.pathname, "?").concat(Object(util_url["c" /* updateQueryString */])({
          page: page + 1
        }, location)),
        previousUrl: "".concat(location.pathname, "?").concat(Object(util_url["c" /* updateQueryString */])({
          page: page - 1
        }, location)),
        pageLanguage: pageLanguage
      });
      jquery_default()('.icon-list.one-column').parent().append(paginationHtml); // Kind of hackish
    }
  }
};

var knowledge_initSearch = function initSearch() {
  jquery_default()('#knowledge-get-results').on('click', function (el) {
    el.preventDefault();
    var category = jquery_default()('#category-select').text().trim();
    var url = el.currentTarget;
    var qs = Object(util_url["c" /* updateQueryString */])({
      category: category
    }, url);
    location.assign("".concat(url.href.split('?')[0], "?").concat(qs));
  });
};

var knowledge_initKnowledgeNav = function initKnowledgeNav() {
  var isKnowledge = jquery_default()('.knowledge-navigation');

  var _getParams = Object(util_url["b" /* getParams */])(location.search),
      section = _getParams.section;

  if (isKnowledge && isKnowledge.length) {
    var tabToShow = isKnowledge.children().first();

    if (section && section.length) {
      if (jquery_default()(".knowledge-navigation div[data-section=\"".concat(section, "\"]")).length) {
        tabToShow = jquery_default()(".knowledge-navigation div[data-section=\"".concat(section, "\"]"));
      }
    }

    isKnowledge.children().hide();
    tabToShow.show();
    var currNavText = jquery_default()('.middle-nav-links li a.active');
    jquery_default()('.mobile-nav-text').text(currNavText.first().text());
    jquery_default()('.main-nav-list a').each(function (i, e) {
      if (jquery_default()(e).text() === currNavText.first().text()) {
        jquery_default()(e).hide();
      }
    });
  }
};

var knowledge_initRelatedArticles = function initRelatedArticles() {
  var articles = jquery_default()('.related-articles-holder .related-article');
  var currentArticle = jquery_default()('.knowledge-article').attr('data-headline');

  if (articles && articles.length) {
    var toShow = Object(toConsumableArray["a" /* default */])(articles);

    jquery_default()(toShow.filter(function (a) {
      return jquery_default()(a).attr('data-headline') !== currentArticle;
    }).sort(function () {
      return Math.random() - 0.5;
    }).splice(0, 3)).show();
  }
};

var knowledge_initBreadcrumbs = function initBreadcrumbs() {
  if (jquery_default()('.knowledge-article').length) {
    var tab = utils_getNavigationTabFromSection(false);
    var tabUrl = tab.find('a').attr('href');
    var baseUrl = getBaseURL(tabUrl); // Translations of 'Knowledge' for different languages.

    var rootLabel = {
      en: 'Knowledge',
      es: 'Conocimientos',
      fr: 'Informations',
      de: 'Wissen',
      nl: 'Informatie'
    };
    var breadcrumbs = [{
      url: "".concat(baseUrl, "/knowledge/explore-cigna.html"),
      label: rootLabel[pageLanguage]
    }];
    var category = jquery_default()('.knowledge-article').attr('data-category');

    if (category) {
      breadcrumbs.push({
        url: "".concat(baseUrl, "/knowledge/search-results.html?category=").concat(category),
        label: category
      });
    } else {
      console.warn('Knowledge Article category is undefined.');
    }

    breadcrumbs.push({
      label: jquery_default()('.knowledge-article').attr('data-headline')
    });
    var html = Object(template["a" /* default */])(breadcrumbs_tpl_default.a, {
      breadcrumbs: breadcrumbs
    });
    jquery_default()('ol.breadcrumb').empty().html(html);
  }
};

var knowledge_updateReadMore = function updateReadMore() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      language = _ref.language;

  var $this = jquery_default()('.readMore-knowledge');
  var lookup = {
    en: 'Read more',
    es: 'Leer más',
    fr: 'En apprendre davantage',
    de: 'Weiterlesen',
    nl: 'Lees meer'
  };
  if ($this.length === 0) return;
  $this.text("".concat(lookup[language] || 'Read more', " >"));
};

/* harmony default export */ var knowledge = (function () {
  knowledge_updateReadMore(utils_getRegionLanguageSection(location.pathname));
  knowledge_selectTab();
  knowledge_initKnowledgeNav();
  knowledge_initHeroAndPromoLinks();
  knowledge_initLinks();
  knowledge_initFooterCategoryLinks();
  knowledge_initFilter();
  knowledge_initSearch();
  knowledge_initBreadcrumbs();
  knowledge_initRelatedArticles();
});
// EXTERNAL MODULE: ./node_modules/cigna-frontend/js/util/delay.js
var delay = __webpack_require__("a+hw");

// CONCATENATED MODULE: ./src/static/js/navigation.js




var navigation_updateTabs = function updateTabs() {
  jquery_default()('.middle-nav-links .nav-item').each(function (i, element) {
    element = jquery_default()(element);
    var section = Object(util_text["b" /* toKebabCase */])(element.text().trim());
    element.attr('data-section', section);
  });
};

var navigation_mobileSubNav = function mobileSubNav(mText) {
  jquery_default()('.mobile-sub-nav-text').text(mText.first().text());
  jquery_default()('.sub-nav-list a').each(function (i, e) {
    if (jquery_default()(e).text() === mText.first().text()) {
      jquery_default()(e).hide();
    }
  });
};

var navigation_initSubNav = function initSubNav() {
  var currPth = window.location.pathname.split('.')[0];
  jquery_default()('.sub-navigation a').removeClass('active');

  if (currPth.indexOf('/knowledge/') > -1) {
    jquery_default()('.sub-navigation a[href*="/knowledge/"]').each(function (i, e) {
      jquery_default()(e).addClass('active');
    });
  } else if (currPth.indexOf('/solutions/') > -1) {
    jquery_default()('.sub-navigation a[href*="/solutions"]').each(function (ix, el) {
      jquery_default()(el).addClass('active');
    });
  } else {
    var activeSub = jquery_default()('.sub-navigation a').filter(function (a, b) {
      return b.href.indexOf(currPth) > -1;
    });

    if (activeSub.length > 1) {
      jquery_default()('.sub-navigation a').first().addClass('active');
    } else {
      jquery_default()(activeSub).addClass('active');
    }
  }

  var mText = jquery_default()('.sub-navigation a.active'); // eslint-disable-next-line no-unused-expressions

  mText.length ? navigation_mobileSubNav(mText) : jquery_default()('.mobile-sub-nav-text').text('Select');
};

/* harmony default export */ var navigation = (function () {
  navigation_updateTabs();
  navigation_initSubNav();
  jquery_default()('.global-nav-toggle').on('click', function (evt) {
    evt.stopPropagation();
    var $nav = jquery_default()('.global-nav-menu');

    if ($nav.hasClass('open')) {
      $nav.removeClass('open');
      jquery_default()('body').removeClass('nav-open');
    } else {
      $nav.addClass('open');
      Object(delay["a" /* default */])(250).then(function () {
        return jquery_default()('body').addClass('nav-open');
      });
    }
  });
  var closable = false;
  var menuOverlay = '<div class="menu-overlay"></div>';
  jquery_default()('.menu-overlay-link .menu-trigger').on('click', function () {
    closable = true;
  });
  jquery_default()('.menu-overlay-link').on({
    'shown.bs.dropdown': function shownBsDropdown() {
      jquery_default()('.cghb-body-content').append(menuOverlay);
      closable = false;
    },
    'hide.bs.dropdown': function hideBsDropdown() {
      if (closable) {
        jquery_default()('.cghb-body-content .menu-overlay').remove();
      }

      return closable;
    }
  });
  jquery_default()('.prevent-anchor').on('click', function (evt) {
    evt.preventDefault();
  });
});
// CONCATENATED MODULE: ./src/static/js/solutions.js




var solutions_initCustomTracking = function initCustomTracking() {
  var _window = window,
      digitalData = _window.digitalData,
      _satellite = _window._satellite;

  if (digitalData && _satellite) {
    jquery_default()(document.body).on('mousedown', '#findSolution', function (evt) {
      var btn = jquery_default()(evt.currentTarget);
      var parts = [];
      btn.closest('.solutionfinder-form').find('[data-selectedvalue]').each(function (index, el) {
        parts.push(jquery_default()(el).attr('data-selectedvalue'));
      });
      digitalData.actions = {
        item: 'findsolutions',
        value: parts.join('|')
      }; // eslint-disable-next-line no-underscore-dangle

      _satellite.track('actiontracking');

      console.debug(digitalData.actions);
    });
  }
};

var solutions_setupSolutionsFinder = function setupSolutionsFinder() {
  var toggleFinderButton = function toggleFinderButton() {
    var dropdowns = jquery_default()('.solutionfinder-form .dropdown-update');
    var selectedDropdowns = Array.from(dropdowns).filter(function (element) {
      element = jquery_default()(element);
      var selectedValue = element.attr('data-selectedvalue');
      var defaultValue = element.attr('data-defaultvalue') || 'Select';
      return selectedValue && selectedValue !== defaultValue; // TODO: find a better way for when there are other languages
    });
    var enabled = dropdowns.length === selectedDropdowns.length;
    jquery_default()('#findSolution').toggleClass('disabled', !enabled);
    jquery_default()('#form-fields').toggleClass('d-none', !enabled);
  };

  toggleFinderButton();
  jquery_default()('.dropdown-update .dropdown-item').on('click', function (evt) {
    var $this = jquery_default()(evt.currentTarget);
    var text = $this.text();
    var value = $this.attr('data-value');
    var id = $this.attr('data-id') || '';
    $this.closest('.dropdown-update').attr('data-selectedvalue', value).find('.dropdown-link').text(text).attr({
      title: text,
      'data-id': id
    });
    toggleFinderButton();
  });
};

var solutions_initFilterSolutions = function initFilterSolutions() {
  if (jquery_default()('#findSolution').length && !jquery_default()('#findSolution').hasClass('disabled')) {
    var locale = jquery_default()('#solution-basedIn').text().trim().toLowerCase();
    var groupsize = jquery_default()('#solution-insuranceGroup').text().trim().toLowerCase();
    var duration = jquery_default()('#solution-duration').text().trim().toLowerCase();

    var noFilter = Object(toConsumableArray["a" /* default */])(new Set([location, groupsize, duration]));

    jquery_default()('#solution-response').removeClass('no-solution-found');
    jquery_default()('.no-solution').hide();

    if (noFilter.length <= 1) {
      jquery_default()('.single-solution').show();
    } else {
      jquery_default()('.single-solution').each(function (i, el) {
        el = jquery_default()(el);
        var locales = [].concat(Object(toConsumableArray["a" /* default */])(el.attr('data-location').toLowerCase().split(', ')), ['all']);
        var groupsizes = [].concat(Object(toConsumableArray["a" /* default */])(el.attr('data-coverage').toLowerCase().split(', ')), ['all']);
        var durations = [].concat(Object(toConsumableArray["a" /* default */])(el.attr('data-duration').toLowerCase().split(', ')), ['all']);

        if (locales.includes(locale) && groupsizes.includes(groupsize) && durations.includes(duration)) {
          el.show();
        }
      });
    }

    if (jquery_default()('.single-solution:visible').length === 0) {
      jquery_default()('#solution-response').addClass('no-solution-found');
      jquery_default()('.no-solution').show();
    }
  }
};

var solutions_toggleFormFields = function toggleFormFields() {
  jquery_default()('li.question').on('click', 'button.dropdown-item', function (evt) {
    var item = jquery_default()(evt.currentTarget).closest('ul').data('name');
    var temp = jquery_default()(evt.currentTarget).data('value');
    jquery_default()("#".concat(item)).val(temp);
  });
};

var solutions_initUpdateRegion = function initUpdateRegion() {
  var params = Object(util_url["b" /* getParams */])(location.search);

  if (params.country && Object(toConsumableArray["a" /* default */])(jquery_default()('.selected-region .dropdown-item:not(.disabled)')).map(function (e) {
    return jquery_default()(e).attr('data-value');
  }).some(function (e) {
    return params.country.includes(e);
  })) {
    var regionSelected = params.country;
    jquery_default()('.selected-region').attr('data-selectedvalue', regionSelected);
    jquery_default()('.region-shown').text(regionSelected);
    jquery_default()('#company-based').val(regionSelected);
  }
};

/* harmony default export */ var solutions = (function () {
  solutions_setupSolutionsFinder();
  solutions_initCustomTracking();
  solutions_initFilterSolutions();
  solutions_toggleFormFields();
  solutions_initUpdateRegion();
  jquery_default()('#findSolution').on('click', function (e) {
    e.preventDefault();
    var isFilter = jquery_default()('.single-solution');
    var isRegionRedirect = jquery_default()('#solution-region');
    var isIgoNgo = jquery_default()('#solution-organization');

    switch (true) {
      case isFilter.length >= 1:
        {
          jquery_default()('.single-solution').hide();
          solutions_initFilterSolutions();
          break;
        }

      case isRegionRedirect.length >= 1:
        {
          var regionClicked = jquery_default()("button[data-value='".concat(isRegionRedirect.text(), "']"));
          var regionPath = regionClicked.attr('href');
          var regionTarget = regionClicked.attr('target') ? regionClicked.attr('target') : '_self';
          window.open(regionPath, regionTarget);
          break;
        }

      case isIgoNgo.length >= 1:
        {
          var organizationType = jquery_default()('#solution-organization').text();
          var organizationId = jquery_default()('#solution-organization').attr('data-id');

          if (organizationType === 'Intergovernmental organization (IGO)') {
            location.assign(jquery_default()("button[data-value='Intergovernmental organization (IGO)']").attr('href'));
          } else if (organizationId === 'IGO') {
            location.assign(jquery_default()("button[data-id='IGO']").attr('href'));
          } else {
            var coverageType = jquery_default()('#solution-coverage').text();
            location.assign(jquery_default()("button[data-value='".concat(coverageType, "']")).attr('href'));
          }

          break;
        }

      default:
        {
          break;
        }
    }
  });
  jquery_default()('.igo-solution-menu button').on('click', function (e) {
    e.preventDefault();
    var organizationType = jquery_default()('#solution-organization').text();
    var igoSolutionMenu = jquery_default()('.dropdown-menu.igo-solution-menu li button'); // eslint-disable-next-line array-callback-return

    Object(toConsumableArray["a" /* default */])(igoSolutionMenu).filter(function (elem, i) {
      if (i === 1 && jquery_default()(elem).text() === organizationType) {
        jquery_default()('#findSolution').removeClass('disabled');
        jquery_default()('.coverage-holder').hide();
      } else if (i === 2 && jquery_default()(elem).text() === organizationType) {
        jquery_default()('.coverage-holder').show();
      } else {
        jquery_default()('.coverage-holder').hide();
      }
    });
  });
});
// EXTERNAL MODULE: ./node_modules/cigna_csg_gsg_elasticsearch/src/js/index.js
var src_js = __webpack_require__("GYF5");

// EXTERNAL MODULE: ./src/static/js/search/views/custom-main-template.tpl.html
var custom_main_template_tpl = __webpack_require__("Yd+E");
var custom_main_template_tpl_default = /*#__PURE__*/__webpack_require__.n(custom_main_template_tpl);

// EXTERNAL MODULE: ./src/static/js/search/views/custom-results.tpl.html
var custom_results_tpl = __webpack_require__("f2KB");
var custom_results_tpl_default = /*#__PURE__*/__webpack_require__.n(custom_results_tpl);

// CONCATENATED MODULE: ./src/static/js/search/index.js






var _getRegionLanguageSec = utils_getRegionLanguageSection(location.pathname),
    search_region = _getRegionLanguageSec.region,
    search_language = _getRegionLanguageSec.language;

jquery_default()('.header-search-input').keyup(function (v) {
  jquery_default()('.header-search-btn').toggleClass('disabled', jquery_default()(v.currentTarget).val().replace(/ /g, '').length <= 0);
});
jquery_default()('.header-search-form').submit(function (a) {
  a.preventDefault();
  jquery_default()('.header-search-input').each(function (i, e) {
    if (jquery_default()(e).val().replace(/ /g, '').length > 0) {
      a.currentTarget.submit();
    }
  });
});
/* harmony default export */ var js_search = (function () {
  if (document.querySelectorAll('[search-results]')) {
    Object(src_js["a" /* SearchResults */])({
      INDEX_SITE: "index-cignaglobalhealth-".concat(search_region, "-").concat(search_language),
      mainTemplate: custom_main_template_tpl_default.a,
      resultTemplate: custom_results_tpl_default.a,
      displayForKeyword: true,
      pagingTop: false,
      pagingBottom: true
    });
  }
});
// CONCATENATED MODULE: ./src/static/js/app.js



















var app_initFrontend = function initFrontend(err) {
  if (err && err instanceof Error) {
    console.error(err);
  }

  if (!storage["a" /* cookie */].isAvailable()) {
    jquery_default()('html').addClass('no-cookie');
  }

  navigation();
  Object(events["a" /* default */])();
  Object(accordions["a" /* default */])();
  Object(share_buttons["initClickHandlers"])(); // change the way frontend default export works

  Object(copyright["a" /* default */])();
  Object(click_tracking["a" /* default */])();
  contact_us();
  knowledge();
  solutions();
  js_search();
};

jquery_default()(function () {
  Object(js["a" /* default */])(app_initFrontend);
});

/***/ }),

/***/ "vwQg":
/***/ (function(module, exports) {

module.exports = "<% if (totalPages > 0 && pageLanguage === 'en') { %>\n  <div class=\"pagination text-uppercase\">\n    <div class=\"row\">\n      <div class=\"col-3\">\n        <% if (page === 1) { %>\n          <span class=\"disabled\">&lt; Back</span>\n        <% } else { %>\n          <a id=\"previousBtn-knowledge\" href=\"<%= previousUrl %>\">&lt; Back</a>\n        <% } %>\n      </div>\n      <div class=\"col-6 text-center\">Showing <%= rangeStart %> - <%= rangeEnd %> of <%= resultCount %> result<% if (resultCount > 1) { %>s<% } %></div>\n      <div class=\"col-3 text-right\">\n        <% if (page === totalPages) { %>\n          <span class=\"disabled\">Next &gt;</span>\n        <% } else { %>\n          <a id=\"nextBtn-knowledge\" href=\"<%= nextUrl %>\">Next &gt;</a>\n        <% } %>\n      </div>\n    </div>\n  </div>\n<% } else if (totalPages > 0 && pageLanguage === 'fr') { %>\n  <div class=\"pagination text-uppercase\">\n    <div class=\"row\">\n      <div class=\"col-3\">\n        <% if (page === 1) { %>\n          <span class=\"disabled\">&lt; Retour</span>\n        <% } else { %>\n          <a id=\"previousBtn-knowledge\" href=\"<%= previousUrl %>\">&lt; Retour</a>\n        <% } %>\n      </div>\n      <div class=\"col-6 text-center\">Montrant <%= rangeStart %> - <%= rangeEnd %> de <%= resultCount %> RÉSULTAT<% if (resultCount > 1) { %>s<% } %></div>\n      <div class=\"col-3 text-right\">\n        <% if (page === totalPages) { %>\n          <span class=\"disabled\">Suivant &gt;</span>\n        <% } else { %>\n          <a id=\"nextBtn-knowledge\" href=\"<%= nextUrl %>\">Suivant &gt;</a>\n        <% } %>\n      </div>\n    </div>\n  </div>\n<% } else if (totalPages > 0 && pageLanguage === 'es') { %>\n  <div class=\"pagination text-uppercase\">\n    <div class=\"row\">\n      <div class=\"col-3\">\n        <% if (page === 1) { %>\n          <span class=\"disabled\">&lt; Anterior</span>\n        <% } else { %>\n          <a id=\"previousBtn-knowledge\" href=\"<%= previousUrl %>\">&lt; Anterior</a>\n        <% } %>\n      </div>\n      <div class=\"col-6 text-center\">Mostrando <%= rangeStart %> - <%= rangeEnd %> de <%= resultCount %> Resultado<% if (resultCount > 1) { %>s<% } %></div>\n      <div class=\"col-3 text-right\">\n        <% if (page === totalPages) { %>\n          <span class=\"disabled\">Siguiente &gt;</span>\n        <% } else { %>\n          <a id=\"nextBtn-knowledge\" href=\"<%= nextUrl %>\">Siguiente &gt;</a>\n        <% } %>\n      </div>\n    </div>\n  </div>\n<% } else if (totalPages > 0 && pageLanguage === 'de') { %>\n  <div class=\"pagination text-uppercase\">\n    <div class=\"row\">\n      <div class=\"col-3\">\n        <% if (page === 1) { %>\n          <span class=\"disabled\">&lt; Zurück</span>\n        <% } else { %>\n          <a id=\"previousBtn-knowledge\" href=\"<%= previousUrl %>\">&lt; Zurück</a>\n        <% } %>\n      </div>\n      <div class=\"col-6 text-center\">Zeigt <%= rangeStart %> - <%= rangeEnd %> von <%= resultCount %> Ergebnis<% if (resultCount > 1) { %>sen<% } %></div>\n      <div class=\"col-3 text-right\">\n        <% if (page === totalPages) { %>\n          <span class=\"disabled\">Weiter &gt;</span>\n        <% } else { %>\n          <a id=\"nextBtn-knowledge\" href=\"<%= nextUrl %>\">Weiter &gt;</a>\n        <% } %>\n      </div>\n    </div>\n  </div>\n<% } else if (totalPages > 0 && pageLanguage === 'nl') { %>\n  <div class=\"pagination text-uppercase\">\n    <div class=\"row\">\n      <div class=\"col-3\">\n        <% if (page === 1) { %>\n          <span class=\"disabled\">&lt; Terug</span>\n        <% } else { %>\n          <a id=\"previousBtn-knowledge\" href=\"<%= previousUrl %>\">&lt; Terug</a>\n        <% } %>\n      </div>\n      <div class=\"col-6 text-center\">Tonen <%= rangeStart %> - <%= rangeEnd %> van <%= resultCount %> resultat<% if (resultCount > 1) { %>en<% } %></div>\n      <div class=\"col-3 text-right\">\n        <% if (page === totalPages) { %>\n          <span class=\"disabled\">Volgende &gt;</span>\n        <% } else { %>\n          <a id=\"nextBtn-knowledge\" href=\"<%= nextUrl %>\">Volgende &gt;</a>\n        <% } %>\n      </div>\n    </div>\n  </div>\n<% } %>\n"

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/www-cignaglobalhealth-com/v1/js/app.787042ac.js